import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import { api, API_URL, toast, React, useState, useEffect } from '../../../services/common';
import { useNavigate, useLocation } from "react-router-dom"; 
import "./BookingForm.css";

const BookingForm = ({ slotId }) => {
  const [studentName, setStudentName] = useState('');
  const [studentEmail, setStudentEmail] = useState('');
  const [studentPhone, setStudentPhone] = useState('');
  const [correctPhone, setCorrectPhone] = useState(false);
  const [courses, setCourses] = useState([]);
  const [selectedCourse, setSelectedCourse] = useState('');
  const [loading, setLoading] = useState(false);
  const [showErrors, setShowErrors] = useState(false);
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  const navigate = useNavigate();
  const location = useLocation();
  const [utmSource, setUtmSource] = useState('');

  const viewCourses = () => {
    setLoading(true);
    api.get(API_URL + '/tutors/view-tutors')
      .then((response) => {
        setLoading(false);
        const tutorsData = response.data;
        const allCourses = tutorsData.reduce((courses, tutor) => {
          const tutorCourses = tutor?.courses?.map(course => ({
            ...course,
            tutor_id: tutor.id,
            tutor: tutor.name
          }));
          if (!tutorCourses || tutorCourses.length === 0) return courses;
          return [...courses, ...tutorCourses];
        }, []);
        setCourses(allCourses);
      })
      .catch((error) => {
        setLoading(false);
        toast.error(error?.response?.data?.message || error.message);
      });
  };
  useEffect(() => {
    // Fetch courses
    viewCourses();
  
    // Extract utm_source from URL params
    const params = new URLSearchParams(window.location.search);
    const source = params.get('utm_source');
    if (source) setUtmSource(source);
  
  }, []);

  const checkPhoneNumber = (value) => {
    setStudentPhone(value);
    setCorrectPhone(value?.length >= 11);
  };

  const addLead = () => {
    setShowErrors(true);
    if (!studentName || !studentEmail || !studentPhone || !correctPhone || !selectedCourse) return;
    if (!emailRegex.test(studentEmail)) return;

    const leadData = {
      name: studentName,
      email: studentEmail,
      phone: "+" + studentPhone,
      course: selectedCourse.name,
      courseId: selectedCourse.id,
      tutor: selectedCourse.tutor,
      tutorId: selectedCourse.tutor_id,
      source: "form",
      utm_source: utmSource || null
    };

    api.post(API_URL + '/common/leads', leadData)
      .then(() => {
        navigate("/book-class/success");
        setStudentName('');
        setStudentEmail('');
        setStudentPhone('');
        setSelectedCourse('');
        setShowErrors(false);
      })
      .catch((error) => {
        toast.error(error?.response?.data?.message || error.message);
      });
  };

  return (
    <div className="booking-bg">
      <div className="booking-overlay">
        <div className="booking-form-card">
          <h4>🎵 Register for Free Masterclass</h4>
          <p className="subtext">
          
            You’ll receive the joining link on WhatsApp after registration.
          </p>

          <div className="form-group">
            <label>Name</label>
            <input 
              type="text" 
              className="form-control"
              placeholder="Your Full Name"
              value={studentName}
              onChange={(e) => setStudentName(e.target.value)}
            />
            {showErrors && !studentName && <span className="error-text">This field is required</span>}
          </div>

          <div className="form-group">
            <label>Email</label>
            <input 
              type="email" 
              className="form-control"
              placeholder="example@gmail.com"
              value={studentEmail}
              onChange={(e) => setStudentEmail(e.target.value)}
            />
            {showErrors && !studentEmail && <span className="error-text">This field is required</span>}
            {showErrors && studentEmail && !emailRegex.test(studentEmail) && (
              <span className="error-text">Please enter a valid email</span>
            )}
          </div>

          <div className="form-group">
            <label>WhatsApp Number</label>
            <PhoneInput
              country={'in'}
              value={studentPhone}
              onChange={(value) => checkPhoneNumber(value)}
            />
            {showErrors && (!studentPhone || !correctPhone) && (
              <span className="error-text">This field is required</span>
            )}
            <p className="note">We'll send reminders and updates via WhatsApp.</p>
          </div>

          <div className="form-group">
            <label>Select a Course</label>
            {loading && <p>Loading courses...</p>}
            {!loading && courses.length > 0 && (
              <div className="course-list-webinar">
                {courses.map((course, index) => (
                  <label key={index} className="course-option">
                    <input
                      type="radio"
                      name="course"
                      value={course.id}
                      checked={selectedCourse?.id === course.id}
                      onChange={() => setSelectedCourse(course)}
                    />
                    {course.name}
                  </label>
                ))}
              </div>
            )}
            {showErrors && !selectedCourse && (
              <span className="error-text">Please select a course</span>
            )}
          </div>

          <button 
            className="btn-submit"
            onClick={addLead}
            id="book-free-masterclass"
          >
            Book Free Masterclass
          </button>
        </div>
      </div>
    </div>
  );
};

export default BookingForm;
